/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automations_DescriptionInputs */

const en_automations_description = /** @type {(inputs: Automations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules that react to case and task changes, the path each case took, and failures to retry.`)
};

const pt_br2_automations_description = /** @type {(inputs: Automations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras que reagem a mudanças em casos e tarefas, o caminho de cada caso e falhas para tentar novamente.`)
};

/**
* | output |
* | --- |
* | "Rules that react to case and task changes, the path each case took, and failures to retry." |
*
* @param {Automations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automations_description = /** @type {((inputs?: Automations_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automations_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automations_description(inputs)
	return pt_br2_automations_description(inputs)
});